import React from 'react';
import '../grammar-page.css';
import { FaBookOpen, FaLightbulb, FaListUl, FaLanguage } from 'react-icons/fa';

const PresentcontinuousExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Present Continuous</h2>

      <p>
        We use the present continuous (am/is/are + verb + -ing) to talk about
        actions happening now or around now, and for future plans.
      </p>

      <div className="grammar-flex-table">
        {[
          ['Affirmative', 'Negative', 'Question'],
          ['I am working', "I am not working", 'Am I working?'],
          ['You are working', "You are not working", 'Are you working?'],
          ['He is working', "He is not working", 'Is he working?'],
          ['She is working', "She is not working", 'Is she working?'],
          ['It is working', "It is not working", 'Is it working?'],
          ['We are working', "We are not working", 'Are we working?'],
          ['They are working', "They are not working", 'Are they working?'],
        ].map(([affirmative, negative, question], index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            <div className="grammar-cell">{affirmative}</div>
            <div className="grammar-cell">{negative}</div>
            <div className="grammar-cell">{question}</div>
          </div>
        ))}
      </div>

      <div className="grammar-explanation-grid">
        <div className="example-block">
          <h3><FaLightbulb /> Contractions</h3>
          <p>We can contract the subject and verb, especially when speaking.</p>
          <ul>
            <li>I am studying. = <strong>I'm</strong> studying.</li>
            <li>You are cooking. = <strong>You're</strong> cooking.</li>
            <li>He is playing football. = <strong>He's</strong> playing football.</li>
            <li>We are waiting. = <strong>We're</strong> waiting.</li>
            <li>They are watching TV. = <strong>They're</strong> watching TV.</li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLightbulb /> Negatives</h3>
          <p>For negatives, use <strong>not</strong> after am, is, or are. We can contract the verb or not.</p>
          <ul>
            <li>I am not working. = <strong>I'm not</strong> working.</li>
            <li>She is not coming. = <strong>She's not</strong> coming. / <strong>She isn't</strong> coming.</li>
            <li>It is not raining. = <strong>It's not</strong> raining. / <strong>It isn't</strong> raining.</li>
            <li>We are not leaving yet. = <strong>We're not</strong> leaving yet. / <strong>We aren't</strong> leaving yet.</li>
            <li>They are not listening. = <strong>They're not</strong> listening. / <strong>They aren't</strong> listening.</li>
          </ul>
        </div>
      </div>

      <div className="grammar-explanation-grid">
        <div className="example-block">
          <h3><FaListUl /> Questions</h3>
          <ul>
            <li>Are you coming?</li>
            <li>Is she sleeping?</li>
            <li>Is it working?</li>
            <li>Are we meeting now?</li>
            <li>Are they studying English?</li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLanguage /> Short Answers</h3>
          <ul>
            <li>Yes, I am. / No, <strong>I'm not</strong>.</li>
            <li>Yes, you are. / No, <strong>you're not</strong>.</li>
            <li>Yes, we are. / No, <strong>we're not</strong>.</li>
            <li>Yes, they are. / No, <strong>they're not</strong>.</li>
            <li>Yes, he is. / No, <strong>he's not</strong>.</li>
            <li>Yes, she is. / No, <strong>she's not</strong>.</li>
            <li>Yes, it is. / No, <strong>it's not</strong>.</li>
          </ul>
          <p><em>Note that with short answers, contractions are only used with negative replies.</em></p>
        </div>
      </div>

      <div className="example-block">
        <h3><FaLightbulb /> Questions with Question Words</h3>
        <ul>
          <li><strong>What</strong> are you doing? – I'm studying.</li>
          <li><strong>Where</strong> is she going? – She's going to the shops.</li>
          <li><strong>Who</strong> are they talking to? – They're talking to the manager.</li>
          <li><strong>Why</strong> are we waiting? – Because the bus is late.</li>
        </ul>
      </div>
    </div>
  );
};

export default PresentcontinuousExplanation;
